import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import CloseIcon from '../../../common/icons/CloseIcon2'

const TitleContainer = styled.div`
  /* width: calc(100% - 30px); */
  box-sizing: border-box;
  height: 31px;
  width: 100%;
  background-color: ${props => props.theme.text};
  padding: 6px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  left: 0;
  top: 0;
`
const TitleText = styled.div`
  height: 19px;
  color: #FFFFFF;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  line-height: 19px;
`
const ButtonsContainer = styled.div`
  display: flex;
`
const ClickableIcon = styled.span`
  color: #FFFFFF;
  cursor: pointer;
  display: flex;
  align-items: center;
  &:nth-of-type(n + 1) {
    margin-left: 15px;
  }
`

const EditorTitle = ({ title, onCloseClick }) => (
  <TitleContainer>
    <TitleText>
      {title}
    </TitleText>
    <ButtonsContainer>
      <ClickableIcon onClick={onCloseClick}>
        <CloseIcon />
      </ClickableIcon>
    </ButtonsContainer>
  </TitleContainer>
)

EditorTitle.propTypes = {
  title: PropTypes.string.isRequired
}

export default EditorTitle
